<div class="main-content py-2 px-0 px-lg-2">
    <div class="section-menu-items">
      <button
        mat-flat-button
        class="item-each"
        [routerLink]="['all-consumers']"
        routerLinkActive="router-link-active"
      >
        <span translate class="translate"> Consumers </span>
        <mat-icon class="ms-2">manage_accounts</mat-icon>
      </button>
    <button
    [disabled]="isButtonDisabled"
      mat-flat-button
      class="item-each"
      [routerLink]="['fee-config/all-fee']"
      routerLinkActive="router-link-active"
      [ngStyle]="{
        display:
          userRole === 'Customer Service'
            ? 'none'
            : 'inline'
      }"
    >
      <span translate class="translate">Fee Configuration</span>
      <mat-icon class="ms-2">manage_accounts</mat-icon>
    </button>
    <button
      [disabled]="isButtonDisabled"
    mat-flat-button
    class="item-each"
    [routerLink]="['consumer-banner']"
    routerLinkActive="router-link-active"
    [ngStyle]="{
      display:
        userRole === 'Customer Service'
          ? 'none'
          : 'inline'
    }"
  >
    <span translate class="translate">Consumer Promotions</span>
    <mat-icon class="ms-2">filter_vintage</mat-icon>
  </button>
  </div>

    <router-outlet></router-outlet>
</div>
